<template>
  <div>
    <v-row class="demo-app-banner" no-gutters align="center" justify="center" v-if="isDemoApp">
      <v-icon small class="mr-2">warning</v-icon>Ceci est un environnement de démonstration, ne pas entrer de données sensibles<v-icon small class="ml-2">warning</v-icon>
    </v-row>
    <div class="topbar">
      <v-row no-gutters justify="center" align="center" class="fill-height">
        <div class="n-container">
          <v-row no-gutters align="center" justify="center" class="mx-6">
            <template v-if="isIndeegoAdminApp">
              <v-btn
                class="secondary-nav-link mr-4"
                icon
                to="/indeego-settings"
              >
                <v-icon left class="nav-icon">chevron_left</v-icon>
                Retour administration Indeego
              </v-btn>
            </template>
            <template v-else>
              <div v-if="!hasMultipleSpaces || isLargeScreen">
                <v-row no-gutters align="center" justify="center" class="client-logo">
                  <img :src="companyLogo" :alt="company.name" v-if="company.name && company.logoUrl && companyLogo">
                  <div class="font-weight-bold px-4" v-else>{{ companyInitials }}</div>
                </v-row>
              </div>
              <div>
                <v-row no-gutters justify="center" align="center" class="nav-links">
                  <v-badge
                    :value="hasInboxInterventions"
                    bordered
                    color="error"
                    :content="countInboxInterventions"
                    class="nav-link-badge"
                    overlap
                    v-if="canSeeInbox"
                  >
                    <router-link to="/inbox" class="nav-link">Inbox</router-link>
                  </v-badge>
                  <router-link to="/interventions" class="nav-link" v-if="rights.interventions">Interventions</router-link>
                  <router-link to="/workload" class="nav-link" v-if="rights.workload">Plan de charge</router-link>
                  <router-link to="/planning" class="nav-link" v-if="canSeePlanning">Planning</router-link>
                  <router-link to="/projects" class="nav-link" v-if="false">Chantiers</router-link>
                  <router-link to="/equipments" class="nav-link" v-if="rights.equipments">Équipements</router-link>
                  <router-link to="/statistics" class="nav-link" v-if="canSeeStatistics">Statistiques</router-link>
                  <!-- <router-link to="/settings" class="nav-link" v-if="canGoToAdmin && rights.administration">Administration</router-link> -->
                </v-row>
              </div>
            </template>
            <v-spacer />
            <div>
              <template v-if="!isIndeegoAdminApp">
                <a
                  href=""
                  class="secondary-nav-link highlighted mr-4"
                  @click.prevent="goToInterventions"
                  v-if="canCreateIntervention && rights.interventions"
                >
                  <v-icon>add</v-icon>
                  Nouvelle intervention
                </a>
                <v-menu
                  v-model="isSearchOpened"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-y
                  bottom
                  v-if="rights.interventions"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="secondary-nav-link mr-4"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon class="nav-icon">search</v-icon>
                    </v-btn>
                  </template>
                  <n-card class="search-card">
                    <v-row no-gutters justify="center" align="center" class="search-card-header">
                      <v-text-field
                        v-model="searchText"
                        placeholder="Rechercher..."
                        background-color="#EFEFEF"
                        @keydown.enter.prevent="goToSearchSelectedInterventionIndex()"
                        @keydown.up.prevent="selectPreviousSearchIntervention()"
                        @keydown.down.prevent="selectNextSearchIntervention()"
                        autofocus
                        clearable
                        hide-details
                        dense
                        solo
                        flat
                      />
                    </v-row>
                    <div class="search-card-results">
                      <v-row no-gutters justify="center" align="center" class="ma-4" v-if="isSearching">
                        <v-progress-linear
                          color="primary"
                          indeterminate
                          rounded
                          height="6"
                        ></v-progress-linear>
                      </v-row>
                      <v-row no-gutters justify="center" align="center" class="search-no-text-or-no-results" v-else-if="isSearchTextEmpty">
                        Commencez à taper pour voir les premiers résultats
                      </v-row>
                      <v-row no-gutters justify="center" align="center" class="search-no-text-or-no-results" v-else-if="hasNoResults">
                        <div><v-icon>search_off</v-icon></div>
                        Désolé, votre recherche n'a retourné aucun résultat
                      </v-row>
                      <template v-else>
                        <template v-for="(intervention, i) in searchResults">
                          <intervention-result-item
                            :key="intervention.id"
                            :value="intervention"
                            class="search-result-item"
                            :class="{ hovered: i === searchSelectedInterventionIndex }"
                            @click="goToIntervention(intervention)"
                            @mouseenter="setSelectedSearchIntervention(intervention)"
                          />
                        </template>
                      </template>
                    </div>
                  </n-card>
                </v-menu>
              </template>
              <user-menu />
            </div>
          </v-row>
        </div>
      </v-row>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import UserMenu from '@/components/UserMenu.vue';
import InterventionResultItem from '@/components/Interventions/ResultItem.vue';

export default {
  name: `Topbar`,
  data: () => ({
    isSearchOpened: false,
    searchText: ``,
    searchSelectedInterventionIndex: 0,
    isSearching: false,
    searchTimeout: null,
  }),
  computed: {
    ...mapState(`model/user`, [
      `me`,
      `isAggregatorUser`,
      `isMakerUser`,
      `isSelfMakerUser`,
    ]),
    ...mapGetters(`model/user`, [
      `isIndeegoUser`,
      `hasMultipleSpaces`,
    ]),
    ...mapState(`model/client`, [
      `company`,
      `rights`,
      `isAggregator`,
    ]),
    ...mapGetters(`model/client`, [
      `isIndeegoAdminApp`,
    ]),
    ...mapState(`ui/mainLayout`, {
      searchResults: `searchResultsInterventions`,
    }),
    ...mapState(`ui/mainLayout`, [
      `isDemoApp`,
    ]),
    ...mapGetters(`ui/mainLayout`, [
      `hasInboxInterventions`,
      `countInboxInterventions`,
      `canSeeInbox`,
    ]),
    isLargeScreen() {
      return this.$vuetify.breakpoint.width > 1400;
    },
    canSeePlanning() {
      return this.isMakerUser || this.isSelfMakerUser;
    },
    canSeeStatistics() {
      return this.isAggregator && (this.isAggregatorUser || this.me.isIndeego) && this.me.clientAdmin && this.company.slug !== `mgl`;
    },
    canCreateIntervention() {
      let can = [`administrator`, `contributor`].includes(this.me.role);

      if (!can) {
        (this.me.rights || []).forEach(userRight => {
          const canOnMaker = userRight.right.id === 3;
          can = can || canOnMaker;
        });
      }

      return can;
    },
    isSearchTextEmpty() {
      return this.searchText === `` || this.searchText === null;
    },
    hasNoResults() {
      return !this.isSearchTextEmpty && !this.isSearching && !this.searchResults.length;
    },
    searchSelectedIntervention() {
      return this.searchResults[this.searchSelectedInterventionIndex];
    },
    companyInitials() {
      const name = (this.company?.name || ``).toUpperCase();

      if (name.length <= 8) { return name; }

      const splittedName = name.split(` `);
      if (splittedName.length > 1) {
        return `${splittedName.map(word => word.substring(0, 1)).join(`.`)}.`;
      }

      return name.substring(0, 3);
    },
    companyLogo() {
      try {
        if (this.company.logoUrl.startsWith(`/`)) {
          return require(`@/assets/slug/${this.company.slug}.png`); // eslint-disable-line
        }
        return this.company.logoUrl;
      } catch (e) {
        return null;
      }
    },
  },
  methods: {
    ...mapActions(`ui/mainLayout`, [
      `initCountInboxInterventions`,
    ]),
    async performSearch() {
      this.isSearching = true;
      this.searchSelectedInterventionIndex = 0;
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(async () => {
        await this.$store.dispatch(`ui/mainLayout/searchInterventions`, this.searchText);
        this.isSearching = false;
      }, 600);
    },
    goToInterventions() {
      if (this.$route.name === `newTicket`) {
        this.$store.dispatch(`ui/newIntervention/changeReloadKey`);
      } else {
        this.$router.push({ name: `newTicket` });
      }
    },
    goToIntervention(intervention) {
      if (this.isSearchTextEmpty || this.hasNoResults) {
        return;
      }
      this.$router.push({
        name: `InterventionsIntervention`,
        params: {
          interventionId: intervention.id,
        },
      });
      this.isSearchOpened = false;
    },
    setSelectedSearchIntervention(intervention) {
      this.searchSelectedInterventionIndex = _.findIndex(this.searchResults, { id: intervention.id });
    },
    selectPreviousSearchIntervention() {
      if (this.searchSelectedInterventionIndex > 0) {
        this.searchSelectedInterventionIndex -= 1;
      }
    },
    selectNextSearchIntervention() {
      if (this.searchSelectedInterventionIndex < (this.searchResults.length - 1)) {
        this.searchSelectedInterventionIndex += 1;
      }
    },
    goToSearchSelectedInterventionIndex() {
      return this.goToIntervention(this.searchSelectedIntervention);
    },
  },
  mounted() {
    if (this.isDemoApp) {
      window.document.title = `Démo Indeego`;
    }
    this.initCountInboxInterventions();
  },
  watch: {
    searchText(searchText) {
      if (_.trim(searchText).length) {
        this.performSearch();
      }
    },
  },
  components: {
    UserMenu,
    InterventionResultItem,
  },
};
</script>

<style lang="scss" scoped>
  $topbar-height: 65px;
  $logo-margin: 9px;
  $logo-max-height: $topbar-height - 2*$logo-margin;
  .topbar {
    position: relative;
    z-index: 100;
    &, * {
      font-size: 12.6px;
    }
    background: #FFF;
    -webkit-box-shadow: 0px 0px 10px 0px rgba(50, 50, 50, 0.5);
    -moz-box-shadow:    0px 0px 10px 0px rgba(50, 50, 50, 0.5);
    box-shadow:         0px 0px 10px 0px rgba(50, 50, 50, 0.5);

    height: $topbar-height;
  }

  .demo-app-banner {
    position: relative;
    background-color: #ce0000;
    height: 30px;
    font-weight: 500;
    font-size: 0.9rem;
    color: #FFF;
    z-index: 100;
    .v-icon {
      color: inherit;
    }
  }

  .client-logo {
    height: $logo-max-height;
    margin: $logo-margin $logo-margin $logo-margin 0px;
    padding: 2px;
    background-color: #FFF;
    border-radius: 5px;
    margin-right: 1rem;

    img {
      max-height: 100%;
      max-width: 100px;
    }
  }

  .nav-link {
    border-radius: 5px;
    border: 1px solid transparent;
    background-color: transparent;
    color: $primaryColor;
    font-weight: 700;
    padding: 6px 15px;
    margin: 0px 5px;
    text-decoration: none !important;
    border: 3px solid transparent;

    &.router-link-active, &:hover {
      background: #FFF;
      -webkit-box-shadow: 2px 2px 8px 2px rgba(19, 26, 154, 0.16);
      -moz-box-shadow:    2px 2px 8px 2px rgba(19, 26, 154, 0.16);
      box-shadow:         2px 2px 8px 2px rgba(19, 26, 154, 0.16);
      border: 3px solid $secondaryColor;
    }
  }

  .nav-icon {
    color: #FFF !important;
    font-size: 1.2rem !important;
    font-weight: 500;
    padding: 5px !important;
    background-color: $primaryColor;
    border-radius: 100%;
    .v-btn & {
      height: auto !important;
      width: auto !important;
    }
  }

  .secondary-nav-link {
    text-decoration: none !important;
    color: #FFF !important;
    font-weight: 500;

    &:hover {
      background-color: saturate($primaryColor, 40);
      -webkit-box-shadow: 2px 2px 12px 3px rgba(19, 26, 154, 0.2);
      -moz-box-shadow:    2px 2px 12px 3px rgba(19, 26, 154, 0.2);
      box-shadow:         2px 2px 12px 3px rgba(19, 26, 154, 0.2);
    }

    &.highlighted {
      padding: 5px !important;
      padding-top: 7px !important;
      padding-bottom: 9px !important;
      padding-right: 10px !important;
      background-color: $primaryColor;
      border-radius: 20px;

      .v-icon {
        color: #FFF;
        font-size: 1.2rem;
        padding: 3px;
      }
    }

    &.v-btn {
      height: auto !important;
      width: auto !important;
      min-width: 0px !important;
      padding: 0 !important;
      text-transform: none;
      letter-spacing: inherit;
    }
  }

  .dropdown-icon {
    font-size: 0.9rem !important;
    color: inherit !important;
    opacity: .7;
  }

  .search-card {
    width: 550px;
  }

  .search-card-header {
    padding: 1rem;
  }

  .search-card-header-cancel {
    text-decoration: none;
  }

  .search-no-text-or-no-results {
    color: #777;
    font-size: 1.3rem;
    text-align: center;
    line-height: 2.4rem;
    margin: 1.4rem 2.4rem 1.4rem;

    .v-icon {
      font-size: 2.5rem;
    }
  }

  .search-card-results {
    padding: 0 1rem 1rem;

    .search-result-item {
      &:hover {
        cursor: pointer;
      }

      &.hovered {
        background-color: #EEE;
      }

      &:not(:last-of-type) {
        border-bottom: 1px solid #CCC;
      }
    }
  }

</style>

<style lang="scss">
  .nav-link-badge {
    .v-badge__wrapper {
      left: -8px !important;
      top: -8px !important;
    }
  }
</style>
